export const FOUNDED = 1997;
